import { ChannelType } from 'components/CampaignCreationModal/Types'
import { StartWithMedia } from '../../components/StartWithMedia/StartWithMedia'
import { RefineDetails } from '../../components/RefineDetails/RefineDetails'
import { MultiStepMobileWizard } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/MultiStepMobileWizard'
import { observer } from 'mobx-react-lite'
import { useMobileWizardCreateDoc } from 'components/Wizards/MobileWizards/hooks/useMobileWizardCreateDoc'
import { SubmitStepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { FlowProps, TextValues } from 'components/Wizards/MobileWizards/Types'

type Values = Pick<
  TextValues,
  'filename' | 'project' | 'topic' | 'tone' | 'language' | 'brand_kit_id' | 'selected_images'
> & { showAddMedia?: boolean }

export const FlowC = observer(({ schema, onClose, initialValues, ...props }: FlowProps<ChannelType>) => {
  const {
    meta: { channel, title },
  } = schema

  const { createDoc } = useMobileWizardCreateDoc(channel, {
    navigateToDocOnComplete: true,
    loadingToast: `Generating your ${title}...`,
  })

  const handleSubmitStep = async ({ values, advance, clearFields, currentStep }: SubmitStepProps<Values>) => {
    if (values.showAddMedia && currentStep === 0) {
      clearFields(['showAddMedia'])
      advance()
      return
    }

    await createDoc(values)
  }

  return (
    <MultiStepMobileWizard
      schema={schema}
      onClose={onClose}
      onSubmitStep={handleSubmitStep}
      initialValues={initialValues}
      {...props}
    >
      <RefineDetails submitLabel="Generate Post" showAddMedia />
      <StartWithMedia skipBackgroundRemoval />
    </MultiStepMobileWizard>
  )
})
